const swiper = new Swiper("#swiper-hero-carousel", {
	// slidesPerView: 3,
    // centeredSlides: true,
	// loop: true,
	spaceBetween: 16,
	loop: true,
	slidesPerView: 1.6,
    slidesOffsetBefore: 0,
	navigation: {
		nextEl: ".custom-swiper-button-next",
		prevEl: ".custom-swiper-button-prev",
	},

	pagination: {
		clickable: true,
		el: ".custom-swiper-pagination",
	},

	breakpoints: {
		320: {
			slidesPerView: 1,
		},
		560: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 1,
		},
		1024: {
            slidesPerView: 1,
		},
		1140: {
            slidesPerView: 1,
            slidesOffsetBefore: 0,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
		},
		1320: {
            slidesPerView: 1,
		},
	},
});


/*
const swiper = new Swiper("#swiper-teacher-es", {
	// slidesPerView: 3,
	// spaceBetween: 16,
	// loop: true,
	loop: true,
	slidesPerView: 1.5,

	navigation: {
		nextEl: ".custom-swiper-button-next",
		prevEl: ".custom-swiper-button-prev",
	},

	pagination: {
		clickable: true,
		el: ".custom-swiper-pagination",
	},

	breakpoints: {
		768: {
			slidesPerView: 3.5,
			centeredSlides: true,
			rewind: true,
		},
		1024: {
		},
		1200: {
		},
		1320: {
		},
	},
});
*/